<h3 class="title configurator-title">{{ 'fence.accessories.title' | translate }}</h3>

<!-- Onglet accessoires -->
<div class="config-container shadow" style="display: none">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 1 }"
    (click)="toggleCollapse(1)">
    <span>{{ 'fence.accessories.accessories' | translate }}</span>
  </h4>
  <div class="collapse-block" *ngIf="subStep === 1"></div>
</div>

<!-- Onglet liste d'outils -->
<div class="config-container shadow mt-4">
  <h4
    class="title configurator-subtitle collapse-button"
    [ngClass]="{ active: subStep === 2 }"
    (click)="toggleCollapse(2)">
    <span>{{ 'fence.accessories.tools' | translate }}</span>
  </h4>
  <div class="collapse-block" *ngIf="subStep === 2">
    <ul class="tools-list">
      <li class="tools-item" *ngFor="let tool of tools">
        <span *ngIf="currentLang === 'fr'">{{ tool.labelFr }}</span>
        <span *ngIf="currentLang === 'en'">{{ tool.labelEn }}</span>
      </li>
    </ul>
  </div>
</div>
